<template>
  <div class="pricing_bonus">

    <v-row style="padding: 10px;">

      <v-col cols="5" style="font-size: 12px;">

        <v-row>
          <v-col cols="12">
            <div style="font-size:20px;height:25px;color:gray;margin-bottom: 10px;">Pricing Bonus Report</div>
            <div>Data Last Refreshed: {{data_last_refreshed ? formatDateTime(data_last_refreshed) : 'data loading...'}}<v-icon icon="mdi-refresh" color="#ff7214" class="text-button cursor-pointer" @click="updateData()" v-if="data_last_refreshed"/></div>

            <div>Quotes File Date: {{formatDateTime(db.last_quotes_file_upload)}}</div>
            <div>Invoices File Date: {{formatDateTime(db.last_invoices_file_upload)}}</div>


            <div>Date Range: {{filters.startDate}} - {{filters.endDate}}</div>
            <div>Excluded Customers: {{filters.excludedCustomers.sort().join(', ')}}</div>
            <div>Acceptance Rate Threshold: {{filters.acceptance_rate_threshold}}%</div>
            <div>Conversion Rate Threshold: {{filters.conversion_rate_threshold}}%</div>
            <div>Bonus Pool: {{formatCurrency(filters.bonus_pool)}}</div>
            <div>OWs: {{ows.slice().sort().join(', ')}}</div>
            <div>AEs: {{aes.slice().sort().join(', ')}}</div>
            <div><v-btn size="xsmall" style="background:#ff7214;color:white;width:105px;font-size:10px" @click="openFilterPopUp()">UPDATE FILTERS</v-btn></div>
            <div style="margin-top:4px"><v-btn size="xsmall" style="background:#ff7214;color:white;width:105px;font-size:10px" @click="openLookupsPopUp()">OVERRIDE RULES</v-btn></div>
          </v-col>
          <v-col cols="12">
            <table v-if="ow_acceptance && ow_conversion">
              <thead>
                <th>OW</th>
                <th style="width:100px">Acceptance Rate</th>
                <th style="width:100px">Conversion Rate</th>
                <th>% of Bonus Pool Allocation</th>
                <th>Max Bonus Amt</th>
                <th>Net Bonus Payout</th>
                <th>Net Bonus Multiplier</th>
                <th>In Bonus Zone?</th>
              </thead>
              <tbody>
                <tr v-for="ow in ows.slice().sort()" :key="ow">
                  <td>{{ow}}</td>
                  <td>{{ow_acceptance[ow] ? (ow_acceptance[ow].accepted / ow_acceptance[ow].quote_and_sonq_lines * 100).toFixed(1) : '0.0'}}%</td>
                  <td>{{ow_conversion[ow] ? (ow_conversion[ow].quotes_converted / ow_conversion[ow].quote_lines * 100).toFixed(1) : '0.0'}}%</td>
                  <td>{{ ow_acceptance[ow] ? ((ow_acceptance[ow].quote_and_sonq_lines /  filteredOwOverrideTotals.line_items) * 100).toFixed(1) : '0.0'}}%</td>
                  <td>{{ow_acceptance[ow] ? formatCurrency(ow_acceptance[ow].quote_and_sonq_lines /  filteredOwOverrideTotals.line_items * filters.bonus_pool) : '$0.00'}}</td>
                  <td>{{isInBonusZone(ow) && ow_acceptance[ow] ? formatCurrency((ow_acceptance[ow].quote_and_sonq_lines /  filteredOwOverrideTotals.line_items * filters.bonus_pool) * (netBonusMultiplier(ow) / 100 )) : '$0.00'}}</td>
                  <td>{{ isInBonusZone(ow) ? netBonusMultiplier(ow).toFixed(1) + '%' : '-' }}</td>
                  <td>{{isInBonusZone(ow) ? '✔' : ''}}</td>
                </tr>
                <tr class="totals-row">
                  <td>TOTALS</td>
                  <td></td>
                  <td></td>
                  <td>{{ totalBonusPoolPercent.toFixed(1) }}%</td>
                  <td>{{ formatCurrency(totalMaxBonusAmt) }}</td>
                  <td>{{ formatCurrency(totalNetBonusPayout) }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>            
            </table>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="7">
         <div style="margin:5px"><ScatterPlot :data='scatterPlotData' :xMin='Number(filters.conversion_rate_threshold)' :yMin='Number(filters.acceptance_rate_threshold)'/></div>
      </v-col>
    </v-row>

    <v-row style="padding: 10px;">
      <v-col cols="5">
        <table>
          <thead>
            <!-- chatGPT - this table here is not showing OW KBL if they have no quotes. i still want to show the initlas if zero -->
            <th>OW</th>
            <th>Quotes Converted</th>
            <th>Quote Lines</th>
            <th>Conversion Rate</th>
          </thead>
          <tbody>
            <tr v-for="ow in ows.slice().sort()" :key="ow">
              <td>{{ ow }}</td>
              <td>{{ (ow_conversion?.[ow]?.quotes_converted ?? 0) }}</td>
              <td>{{ (ow_conversion?.[ow]?.quote_lines ?? 0) }}</td>
              <td>
                {{
                  (ow_conversion?.[ow]?.quote_lines ?? 0)
                    ? (((ow_conversion[ow].quotes_converted ?? 0) / (ow_conversion[ow].quote_lines ?? 0)) * 100).toFixed(1)
                    : '0.0'
                }}%
              </td>
            </tr>            
            <tr class="totals-row">
              <td>TOTALS</td>
              <td>{{filteredOwConvertedTotals.quotes_converted}}</td>
              <td>{{filteredOwConvertedTotals.quote_lines}}</td>
              <td>{{filteredOwConvertedTotals.conversion_rate}}%</td>
            </tr>
          </tbody>
        </table>    
      </v-col>

      <v-col cols="7">
        <table v-if="ow_acceptance">
          <thead>
            <th>OW</th>
            <th>Line Item Overrides*</th>
            <th>Quotes and SONQ Lines</th>
            <th>Override Rate</th>
            <th>% of Total</th>
          </thead>
          <tbody>
            <tr v-for="([ow, data]) in Object.entries(ow_acceptance).filter(([ow]) => ows.includes(ow)).sort(([a], [b]) => a.localeCompare(b))" :key="ow">
              <td>{{ow}}</td>
              <td>{{data.quote_and_sonq_lines - data.accepted}}</td>
              <td>{{data.quote_and_sonq_lines}}</td>
              <td>{{ data.quote_and_sonq_lines ? ((((data.quote_and_sonq_lines - data.accepted) / data.quote_and_sonq_lines) * 100).toFixed(1)) : '0.0' }}%</td>
              <td>{{ data.quote_and_sonq_lines ? ((data.quote_and_sonq_lines /  filteredOwOverrideTotals.line_items) * 100).toFixed(1) : '0.0'}}%</td>
            </tr>
            <tr class="totals-row">
              <td>TOTALS</td>
              <td>{{filteredOwOverrideTotals.line_overrides}}</td>
              <td>{{filteredOwOverrideTotals.line_items}}</td>
              <td>{{filteredOwOverrideTotals.override_rate}}%</td>
              <td>100%</td>
            </tr>                   
          </tbody>            
        </table>
        <div class="table-note">*excludes price increases</div>
      </v-col>

      <v-col cols="5">
        <table>
          <thead>
            <th>AE</th>
            <th>Quotes Converted</th>
            <th>Quote Lines</th>
            <th>Conversion Rate</th>
          </thead>
          <tbody>
<!--             <tr v-for="([ae, data]) in Object.entries(ae_conversion).filter(([ae]) => aes.includes(ae)).sort(([a], [b]) => a.localeCompare(b))" :key="ae">
              <td>{{ae}}</td>
              <td>{{data.quotes_converted}}</td>
              <td>{{data.quote_lines}}</td>
              <td>{{ data.quote_lines ? ((data.quotes_converted / data.quote_lines) * 100).toFixed(1) : '0.0' }}%</td>
            </tr> -->
            <tr v-for="ae in aes.slice().sort()" :key="ae">
              <td>{{ ae }}</td>
              <td>{{ (ae_conversion?.[ae]?.quotes_converted ?? 0) }}</td>
              <td>{{ (ae_conversion?.[ae]?.quote_lines ?? 0) }}</td>
              <td>
                {{
                  (ae_conversion?.[ae]?.quote_lines ?? 0)
                    ? (((ae_conversion[ae].quotes_converted ?? 0) / (ae_conversion[ae].quote_lines ?? 0)) * 100).toFixed(1)
                    : '0.0'
                }}%
              </td>
            </tr>            
            <tr class="totals-row">
              <td>TOTALS</td>
              <td>{{filteredAeConvertedTotals.quotes_converted}}</td>
              <td>{{filteredAeConvertedTotals.quote_lines}}</td>
              <td>{{filteredAeConvertedTotals.conversion_rate}}%</td>
            </tr>                 
          </tbody>

        </table>          
      </v-col>

      <v-col cols="7">
        <table v-if="ae_acceptance">
          <thead>
            <th>AE</th>
            <th>Line Item Overrides*</th>
            <th>Quotes and SONQ Lines</th>
            <th>Override Rate</th>
            <th>% of Total</th>
          </thead>
          <tbody>
            <tr v-for="([ae, data]) in Object.entries(ae_acceptance).filter(([ae]) => aes.includes(ae)).sort(([a], [b]) => a.localeCompare(b))" :key="ow">
              <td>{{ae}}</td>
              <td>{{data.quote_and_sonq_lines - data.accepted}}</td>
              <td>{{data.quote_and_sonq_lines}}</td>
              <td>{{ data.quote_and_sonq_lines ? ((((data.quote_and_sonq_lines - data.accepted) / data.quote_and_sonq_lines) * 100).toFixed(1)) : '0.0' }}%</td>
              <td>{{ data.quote_and_sonq_lines ? ((data.quote_and_sonq_lines /  filteredAeOverrideTotals.line_items) * 100).toFixed(1) : '0.0'}}%</td>
            </tr>
            <tr class="totals-row">
              <td>TOTALS</td>
              <td>{{filteredAeOverrideTotals.line_overrides}}</td>
              <td>{{filteredAeOverrideTotals.line_items}}</td>
              <td>{{filteredAeOverrideTotals.override_rate}}%</td>
              <td>100%</td>
            </tr>                      
          </tbody>   
        </table>
        <div class="table-note">*excludes price increases</div>     
      </v-col>
 
    </v-row>
    <hr>
    <v-row align="center" justify="space-between" style="margin:0">
      <v-col cols="auto">
        <div style="width:350px;">
          <v-text-field
            label="Search..."
            variant="solo"
            density="compact"
            hide-details="true"
            @input="debouncedSearch($event)"
          />
        </div>
      </v-col>

      <v-col cols="auto" class="text-right">
    <v-btn style="background:#ff7214;color:white;height:15px;width:50px;font-size:8px;" @click="exportTable()" :disabled="false">EXPORT</v-btn>
      </v-col>
    </v-row>

    <div class="table-container">
        <Vue3EasyDataTable
          :headers="headers"
          :items="table_data_arr"
          :search-value="searchValue"
          :sort-by="sortBy"
          :sort-type="sortType"
          :table-height="table_height"
          :rows-per-page="250"
          :rows-items="[250, 500, 1000, 5000]"
          :hide-rows-per-page="false"
          :hide-footer="false"
        >

        <template #header-id="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-quote_converted="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-line_item_type="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-override_type="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-parsed_system_price_method="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-concat_customer_number_product_25="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-concat_customer_category_product_25="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-concat_customer_category_product_line_code="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-unconverted_reason="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #header-exclusion_approval_status="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #item-order_date_sortable="item">            
          <div class="">
            <div class="">{{item.order_date}}</div>
          </div>            
        </template>

        <template #item-invoice_date_sortable="item">            
          <div class="">
            <div class="">{{item.invoice_date}}</div>
          </div>
        </template>

        <template #item-id="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.id}}</div>
          </div>            
        </template>

        <template #item-quote_converted="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.quote_converted}}</div>
          </div>            
        </template>

        <template #item-line_item_type="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.line_item_type}}</div>
          </div>            
        </template>


        <template #item-override_type="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.override_type}}</div>
          </div>            
        </template>

        <template #item-parsed_system_price_method="item">
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.parsed_system_price_method}}</div>
          </div>
        </template>

        <template #header-override_lookup_found="header">
          <div class="calculated-column">
            <div class="calculated-column-text">{{header.text}}</div>
          </div>
        </template>

        <template #item-override_lookup_found="item">
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.override_lookup_found}}</div>
          </div>
        </template>

        <template #item-concat_customer_number_product_25="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.concat_customer_number_product_25}}</div>
          </div>            
        </template>

        <template #item-concat_customer_category_product_25="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.concat_customer_category_product_25}}</div>
          </div>            
        </template>

        <template #item-concat_customer_category_product_line_code="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.concat_customer_category_product_line_code}}</div>
          </div>            
        </template>

        <template #item-unconverted_reason="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.unconverted_reason}}</div>
          </div>            
        </template>

        <template #item-exclusion_approval_status="item">            
          <div class="calculated-column">
            <div class="calculated-column-text">{{item.exclusion_approval_status}}</div>
          </div>            
        </template>

      </Vue3EasyDataTable>
    </div>

    
  </div>


  <PricingBonusReportFilterPopUp
    v-if="filter_popup"
    :initialFilters="filters"
    :ows="ows"
    :aes="aes"
    @close="filter_popup = false"
    @apply="applyFilters"
  />
  <UpdateL1L3L4RulesPopUp
    v-if="lookups_popup"
    @close="lookups_popup = false"
    @saved="updateData()"
  />

</template>

<script>

import firebase from 'firebase/compat/app';
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import { getDatabase, ref, get, query, orderByChild, equalTo, onChildAdded, onChildChanged, onChildRemoved } from 'firebase/database';
import { debounce } from 'lodash';
import ScatterPlot from '@/components/ConversionAcceptanceScatterPlot.vue'
import XLSX from 'xlsx'

import PricingBonusReportFilterPopUp from '@/components/PricingBonusReportFilterPopUp.vue'
import UpdateL1L3L4RulesPopUp from '@/components/UpdateL1L3L4RulesPopUp.vue'

export default {
  name: 'Pricing Bonus Report',
  components: {Vue3EasyDataTable,ScatterPlot,PricingBonusReportFilterPopUp,UpdateL1L3L4RulesPopUp},
  data(){
    return {
      filelist: [],
      searchValue: '',
      sortBy: '',
      sortType: 'asc',
      table_height: 350,
      data_last_refreshed: false,
      scatterPlotData: [],
      filter_popup: false,
      lookups_popup: false,
      headers: [
        { text: "Order Date", value: "order_date_sortable", sortable: true },
        { text: "Order Number", value: "order_number", sortable: true },
        { text: "Invoice Date", value: "invoice_date_sortable", sortable: true },
        { text: "Invoice Number", value: "invoice_number", sortable: true },
        { text: "Product (25)", value: "product", sortable: true },
        { text: "Product Major Group", value: "product_major_group", sortable: true },
        { text: "Product Line Code", value: "product_line_code", sortable: true },
        { text: "Price Method", value: "price_method", sortable: true },
        { text: "Original Net Price", value: "original_net_price", sortable: true },
        { text: "Net Price", value: "net_price", sortable: true },        
        { text: "Calculated Price Method", value: "calculated_price_method", sortable: true },
        { text: "Complete Order Status", value: "complete_order_status", sortable: true },
        { text: "Customer Name", value: "customer_name", sortable: true },
        { text: "Customer Number", value: "customer_number", sortable: true },
        { text: "Customer Master AR Account", value: "customer_master_ar_account", sortable: true },
        { text: "Customer Macro Account Number", value: "customer_macro_account_number", sortable: true },
        { text: "Customer Category", value: "customer_category", sortable: true },
        { text: "Order Writer", value: "order_writer", sortable: true },
        { text: "Salesman Code", value: "salesman_code", sortable: true },
        { text: "Extension", value: "extension", sortable: true },
        { text: "Invoice Line Extension", value: "invoice_line_extension", sortable: true },
        { text: "Special Inst Flat", value: "special_inst_flat", sortable: true },
        { text: "Converted Quote Number", value: "converted_quote_number", sortable: true },
        { text: "Internal Comments Flat", value: "internal_comments_flat", sortable: true },
        { text: "Branch", value: "branch", sortable: true },
        { text: "ID", value: "id", sortable: true },
        { text: "QUOTE CONVERTED", value: "quote_converted", sortable: true },
        { text: "LINE ITEM TYPE", value: "line_item_type", sortable: true },
        { text: "OVERRIDE TYPE", value: "override_type", sortable: true },
        { text: "PARSED SYSTEM PRICE METHOD", value: "parsed_system_price_method", sortable: true },
        { text: "OVERRIDE LOOKUP FOUND", value: "override_lookup_found", sortable: true },
        { text: "CUSTOMER NUMBER + PRODUCT (25)", value: "concat_customer_number_product_25", sortable: true },
        { text: "CUSTOMER CATEGORY + PRODUCT (25)", value: "concat_customer_category_product_25", sortable: true },
        { text: "CUSTOMER CATEGORY + PRODUCT LINE CODE", value: "concat_customer_category_product_line_code", sortable: true },
        { text: "UNCONVERTED REASON", value: "unconverted_reason", sortable: true },
        { text: "EXCLUSION APPROVAL STATUS", value: "exclusion_approval_status", sortable: true },
      ],
      ows: [],
      aes: [],
      table_data_arr: [],
      ae_conversion: {},
      ow_conversion: {},
      ae_acceptance: {},
      ow_acceptance: {},
      filters: {
        startDate: Moment().subtract(1, 'month').startOf('month').format('MM/DD/YYYY'),
        endDate: Moment().subtract(1, 'month').endOf('month').format('MM/DD/YYYY'),
        excludedCustomers: [],
        acceptance_rate_threshold: 0,
        conversion_rate_threshold: 0,
        bonus_pool: 0

        // excludedCustomers: ['1637'],
        // acceptance_rate_threshold: 70,
        // conversion_rate_threshold: 60,
        // bonus_pool: 5600
      }      
    }
  },
  created() {
    this.sizeTable()
    window.addEventListener("resize", this.sizeTable);
  },
  destroyed() {
    window.removeEventListener("resize", this.sizeTable);
  },
  beforeMount(){
    var self = this

    if(this.user === 'vendor' || !this.user){
      this.$router.push('/')
    }

    this.updateFiltersFromDB()
    this.$store.state.isLoading = true
  },
  mounted() {
    this.updateData()
  },
  computed: {
    ...mapGetters(['user','db','l1_lookup','l3_lookup','l4_lookup']),
    filteredOwConvertedTotals() {
      // Filter your data by the same initials array
      const filteredEntries = Object.entries(this.ow_conversion)
        .filter(([ow]) => this.ows.includes(ow))
        .sort(([a], [b]) => a.localeCompare(b));
      
      // Calculate totals from filtered data only
      const totals = filteredEntries.reduce((acc, [ow, data]) => {
        acc.quotes_converted += data.quotes_converted;
        acc.quote_lines += data.quote_lines;
        return acc;
      }, { quotes_converted: 0, quote_lines: 0 });
      
      // Add conversion rate
      totals.conversion_rate = totals.quote_lines ? ((totals.quotes_converted / totals.quote_lines) * 100).toFixed(1) : '0.0';
      
      return totals;
    },
    filteredAeConvertedTotals(){
      // Filter your data by the same initials array
      const filteredEntries = Object.entries(this.ae_conversion)
        .filter(([ae]) => this.aes.includes(ae))
        .sort(([a], [b]) => a.localeCompare(b));
      
      // Calculate totals from filtered data only
      const totals = filteredEntries.reduce((acc, [ae, data]) => {
        acc.quotes_converted += data.quotes_converted;
        acc.quote_lines += data.quote_lines;
        return acc;
      }, { quotes_converted: 0, quote_lines: 0 });
      
      // Add conversion rate
      totals.conversion_rate = totals.quote_lines ? ((totals.quotes_converted / totals.quote_lines) * 100).toFixed(1) : '0.0';
      
      return totals;      
    },
    filteredOwOverrideTotals(){
      const filteredEntries = Object.entries(this.ow_acceptance || {})
        .filter(([ow]) => this.ows.includes(ow))
        .sort(([a], [b]) => a.localeCompare(b))

      const totals = filteredEntries.reduce(
        (acc, [ow, data]) => {
          const lineItems = Number(data.quote_and_sonq_lines || 0)
          const accepted = Number(data.accepted || 0)
          acc.line_items += lineItems
          acc.line_overrides += Math.max(0, lineItems - accepted)
          return acc
        },
        { line_overrides: 0, line_items: 0 }
      )

      totals.override_rate = totals.line_items
        ? ((totals.line_overrides / totals.line_items) * 100).toFixed(1)
        : '0.0'

      return totals
    },
    filteredAeOverrideTotals(){
      const filteredEntries = Object.entries(this.ae_acceptance || {})
        .filter(([ae]) => this.aes.includes(ae))
        .sort(([a], [b]) => a.localeCompare(b))

      const totals = filteredEntries.reduce(
        (acc, [ae, data]) => {
          const lineItems = Number(data.quote_and_sonq_lines || 0)
          const accepted = Number(data.accepted || 0)
          acc.line_items += lineItems
          acc.line_overrides += Math.max(0, lineItems - accepted)
          return acc
        },
        { line_overrides: 0, line_items: 0 }
      )

      totals.override_rate = totals.line_items
        ? ((totals.line_overrides / totals.line_items) * 100).toFixed(1)
        : '0.0'

      return totals
    },
    totalBonusPoolPercent() {
      return this.ows.reduce((sum, ow) => {
        if (!this.ow_acceptance[ow]) return sum
        return sum + (this.ow_acceptance[ow].quote_and_sonq_lines / this.filteredOwOverrideTotals.line_items) * 100
      }, 0)
    },

    totalMaxBonusAmt() {
      return this.ows.reduce((sum, ow) => {
        if (!this.ow_acceptance[ow]) return sum
        return sum + (this.ow_acceptance[ow].quote_and_sonq_lines / this.filteredOwOverrideTotals.line_items) * this.filters.bonus_pool
      }, 0)
    },

    totalNetBonusPayout() {
      return this.ows.reduce((sum, ow) => {
        if (!this.isInBonusZone(ow) || !this.ow_acceptance[ow]) return sum
        return sum +
          ((this.ow_acceptance[ow].quote_and_sonq_lines / this.filteredOwOverrideTotals.line_items) * this.filters.bonus_pool) *
          (this.netBonusMultiplier(ow) / 100)
      }, 0)
    }     
  },
  methods: {
    async updateData() {
      this.$store.state.isLoading = true;

      await this.updateFiltersFromDB()

      const db = getDatabase();
      const quotesRef = ref(db, 'quotes');
      const invoicesRef = ref(db, 'invoices');
      const startDate = Moment(this.filters.startDate, 'MM/DD/YYYY').startOf('day');
      const endDate = Moment(this.filters.endDate, 'MM/DD/YYYY').endOf('day');
      const excludedCustomers = this.filters.excludedCustomers || [];

      try {
        const [quotesSnap, invoicesSnap] = await Promise.all([
          get(quotesRef),
          get(invoicesRef),
        ]);

        this.table_data_arr = [];
        this.ae_conversion = {}
        this.ow_conversion = {}
        this.ae_acceptance = {}
        this.ow_acceptance = {}

        if (quotesSnap.exists()) {
          quotesSnap.forEach((snapshot) => {
            const quote = snapshot.val();
            quote.order_date_sortable = Moment(quote.order_date).startOf('day').valueOf()
            quote.invoice_date_sortable = quote.invoice_date ? Moment(quote.invoice_date).startOf('day').valueOf() : 0

            const orderDate = Moment(quote.order_date, 'MM/DD/YYYY', true);
            if (!orderDate.isValid() || !orderDate.isBetween(startDate, endDate, 'day', '[]')) {
              return;
            }

            if (excludedCustomers.includes(String(quote.customer_number))) return

            quote.id = snapshot.key;
            quote.concat_customer_number_product_25 = quote.customer_number + ' ' + quote.product;
            quote.concat_customer_category_product_25 = quote.customer_category + ' ' + quote.product;
            quote.concat_customer_category_product_line_code = quote.customer_category + ' ' + quote.product_line_code;
            quote.parsed_system_price_method = this.getQuoteParsedSystemPriceMethod(quote);
            quote.override_lookup_found = this.getQuoteOverrideLookupFound(quote);
            quote.override_type = quote.price_method === 'Override' ? 'Price Decrease' : 'None';
            quote.line_item_type = 'QUOTE';
            quote.quote_converted = quote.sales_order_converted ? 'CONVERTED' : '';

            quote.exclusion_approval_status = quote.exclusion_approval_status  || ''
            quote.unconverted_reason = quote.unconverted_reason  || ''

            if ((quote.parsed_system_price_method === 'L3' || quote.parsed_system_price_method === 'L4') && quote.exclusion_approval_status !== 'Approved') {
              
              // CONVERSION
              if(!this.ow_conversion[quote.order_writer]){
                this.ow_conversion[quote.order_writer] = { quote_lines: 0, quotes_converted: 0 }
              }

              if(!this.ae_conversion[quote.salesman_code]){
                this.ae_conversion[quote.salesman_code] = { quote_lines: 0, quotes_converted: 0 }
              }

              this.ow_conversion[quote.order_writer].quote_lines++;
              this.ae_conversion[quote.salesman_code].quote_lines++;

              if (quote.quote_converted === 'CONVERTED') {
                this.ow_conversion[quote.order_writer].quotes_converted++;
                this.ae_conversion[quote.salesman_code].quotes_converted++;                
              }

              // ACCEPTANCE
              if (!this.ow_acceptance[quote.order_writer]) {
                this.ow_acceptance[quote.order_writer] = { quote_and_sonq_lines: 0, accepted: 0 };
              }
              if (!this.ae_acceptance[quote.salesman_code]) {
                this.ae_acceptance[quote.salesman_code] = { quote_and_sonq_lines: 0, accepted: 0 };
              }
              this.ow_acceptance[quote.order_writer].quote_and_sonq_lines++;
              this.ae_acceptance[quote.salesman_code].quote_and_sonq_lines++;

              if(quote.override_type === 'None' || quote.override_type === 'Price Increase'){
                this.ow_acceptance[quote.order_writer].accepted++;
                this.ae_acceptance[quote.salesman_code].accepted++;
              }
            }

            this.table_data_arr.push(quote);

          });
        }
        if (invoicesSnap.exists()) {
          invoicesSnap.forEach((snapshot) => {
            const invoice = snapshot.val();
            invoice.order_date_sortable = Moment(invoice.order_date).startOf('day').valueOf()
            invoice.invoice_date_sortable = invoice.invoice_date ? Moment(invoice.invoice_date).startOf('day').valueOf() : 0

            const orderDate = Moment(invoice.order_date, 'MM/DD/YYYY', true);
            if (!orderDate.isValid() || !orderDate.isBetween(startDate, endDate, 'day', '[]')) {
              return;
            }

            if (excludedCustomers.includes(String(invoice.customer_number))) return

            invoice.id = snapshot.key;
            invoice.concat_customer_number_product_25 = invoice.customer_number + ' ' + invoice.product;
            invoice.concat_customer_category_product_25 = invoice.customer_category + ' ' + invoice.product;
            invoice.concat_customer_category_product_line_code = invoice.customer_category + ' ' + invoice.product_line_code;
            invoice.parsed_system_price_method = this.getInvoiceParsedSystemPriceMethod(invoice);

            invoice.exclusion_approval_status = ''
            invoice.unconverted_reason = ''

            invoice.line_item_type =
              (invoice.converted_quote_number && invoice.converted_quote_number.trim() !== '') ||
              invoice.special_inst_flat?.toLowerCase().startsWith('quote number')
                ? 'SO WITH QUOTE'
                : 'SO NO QUOTE';

            invoice.quote_converted = '';
            
            const net = parseFloat(invoice.net_price);
            const originalNet = parseFloat(invoice.original_net_price);

            if (invoice.price_method === 'Override') {
              if (net > originalNet) {
                invoice.override_type = 'Price Increase';
              } else if (net <= originalNet || net === 0 || originalNet === 0) {
                invoice.override_type = 'Price Decrease';
              }
            } else {
              invoice.override_type = 'None';
            }

            // ACCEPTANCE
            if(invoice.line_item_type === 'SO NO QUOTE' && (invoice.parsed_system_price_method === 'L3' || invoice.parsed_system_price_method === 'L4') ){
              if (!this.ow_acceptance[invoice.order_writer]) {
                this.ow_acceptance[invoice.order_writer] = { quote_and_sonq_lines: 0, accepted: 0 };
              }
              if (!this.ae_acceptance[invoice.salesman_code]) {
                this.ae_acceptance[invoice.salesman_code] = { quote_and_sonq_lines: 0, accepted: 0 };
              }              
              this.ow_acceptance[invoice.order_writer].quote_and_sonq_lines++;
              this.ae_acceptance[invoice.salesman_code].quote_and_sonq_lines++;

              if(invoice.override_type === 'None' || invoice.override_type === 'Price Increase'){
                this.ow_acceptance[invoice.order_writer].accepted++;
                this.ae_acceptance[invoice.salesman_code].accepted++;                    
              }
            }

            this.table_data_arr.push(invoice);
            
          });
        }
      } finally {

        const aes = this.aes
        const ows = this.ows

        var scatter_arr = []
        
        for(var i = 0; i < aes.length; i++){
          var ae = aes[i]
          var convObj = this.ae_conversion[ae] || { quotes_converted: 0, quote_lines: 0 }
          var accObj = this.ae_acceptance[ae] || { accepted: 0, quote_and_sonq_lines: 0 }

          var conversion_rate = this.rate(convObj.quotes_converted, convObj.quote_lines)
          var acceptance_rate = this.rate(accObj.accepted, accObj.quote_and_sonq_lines)

          scatter_arr.push({ x: conversion_rate, y: acceptance_rate, label: ae })
        }

        for(var i = 0; i < ows.length; i++){
          var ow = ows[i]
          var convObj = this.ow_conversion[ow] || { quotes_converted: 0, quote_lines: 0 }
          var accObj = this.ow_acceptance[ow] || { accepted: 0, quote_and_sonq_lines: 0 }

          var conversion_rate = this.rate(convObj.quotes_converted, convObj.quote_lines)
          var acceptance_rate = this.rate(accObj.accepted, accObj.quote_and_sonq_lines)

          scatter_arr.push({ x: conversion_rate, y: acceptance_rate, label: ow })
        }

        this.scatterPlotData = scatter_arr
        setTimeout(() => {
          this.data_last_refreshed = Date.now()
          this.$store.state.isLoading = false;
        }, 2000);
      }
    },
    async updateFiltersFromDB(){
      const snapshot = await firebase.database().ref('kpi_settings').once('value')
      const val = snapshot.val() || {}

      const raw = val.excludedCustomers

      this.filters.excludedCustomers = Array.isArray(raw)
        ? raw.map(String)
        : Object.values(raw || {}).map(String)

      this.filters.acceptance_rate_threshold = val.acceptance_rate_threshold
      this.filters.conversion_rate_threshold = val.conversion_rate_threshold
      this.filters.bonus_pool = val.bonus_pool
      this.ows = Object.values(val.ows || {})
      this.aes = Object.values(val.aes || {})
    },
    normalizeExcludedCustomers(list){
      return (list || [])
        .map(String)
        .map(v => v.trim())
        .filter(v => v) // keep non-empty
    },
    rate(n, d) {
      if (!d) return 0
      return Number(((n / d) * 100).toFixed(1))
    },
    formatCurrency(value) {
      const absoluteValue = Math.abs(value);
      const sign = value < 0 ? "-" : "";
      const formattedValue = absoluteValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return `${sign}$${formattedValue}`;
    },    
    async applyFilters(payload) {
      this.ows = payload.ows || []
      this.aes = payload.aes || []
      this.filters = payload
      this.filter_popup = false

      const excluded = this.normalizeExcludedCustomers(this.filters.excludedCustomers)

      await firebase.database().ref('kpi_settings').update({
        acceptance_rate_threshold: Number(this.filters.acceptance_rate_threshold),
        conversion_rate_threshold: Number(this.filters.conversion_rate_threshold),
        bonus_pool: Number(this.filters.bonus_pool),
        excludedCustomers: excluded,
        ows: this.ows,
        aes: this.aes
      })

      this.filters.excludedCustomers = excluded
      this.updateData()
    },
    openFilterPopUp(){
      this.filter_popup = true
    },
    openLookupsPopUp(){
      this.lookups_popup = true
    },
    isInBonusZone(ow){
      const a = this.ow_acceptance?.[ow]
      const c = this.ow_conversion?.[ow]
      if(!a || !c) return false

      const aDen = Number(a.quote_and_sonq_lines || 0)
      const cDen = Number(c.quote_lines || 0)
      if(aDen <= 0 || cDen <= 0) return false

      const acceptanceRate = (Number(a.accepted || 0) / aDen) * 100
      const conversionRate = (Number(c.quotes_converted || 0) / cDen) * 100

      return (
        acceptanceRate >= Number(this.filters.acceptance_rate_threshold) &&
        conversionRate >= Number(this.filters.conversion_rate_threshold)
      )
    },
    netBonusMultiplier(ow){
      const a = this.ow_acceptance?.[ow]
      const c = this.ow_conversion?.[ow]

      if(!a || !c) return 0

      const aDen = Number(a.quote_and_sonq_lines || 0)
      const cDen = Number(c.quote_lines || 0)
      if(aDen <= 0 || cDen <= 0) return 0

      const acceptanceRate = (Number(a.accepted || 0) / aDen) * 100
      const conversionRate = (Number(c.quotes_converted || 0) / cDen) * 100

      return (acceptanceRate * conversionRate) / 100
    },
    exportTable(){
        var items = this.table_data_arr
        var export_arr = []

        for(var i = 0; i < items.length; i++){
          var item = items[i]
          // var row_item = {
          //   'Flag' : item.flag,
          //   'PO Number' : item.po_number,
          //   'PO Date': item.po_date_formatted,
          //   'Buyer': item.buyer_name,
          //   'RH Product #': item.product,
          //   'Product Description': item.product_description,
          //   'Vendor': item.vendor_name,
          //   'Item ETA': item.eta,
          //   'Days Past Due': item.remaining_lead_time_days === 9999 ? item.eta : Math.abs(item.remaining_lead_time_days) + ' Days Past Due',
          //   'Internal Notes': '',
          //   'Shared Notes': ''
          // }

          export_arr.push(item)
        }

        // var wscols = [
        //     {wch:10},
        //     {wch:30},
        //     {wch:30},
        //     {wch:30},
        //     {wch:30},
        //     {wch:30},
        //     {wch:30},
        //     {wch:30},
        //     {wch:30},
        // ];

        var worksheet = XLSX.utils.json_to_sheet(export_arr)
        // worksheet['!cols'] = wscols;
        var workbook = XLSX.utils.book_new()
        var export_date = Date.now()
        XLSX.utils.book_append_sheet(workbook, worksheet)
        XLSX.writeFile(workbook, 'KPI Table ' + export_date + '.xlsx')
    },
    getQuoteParsedSystemPriceMethod(quote){
      var branch = quote.branch
      var customer_category = quote.customer_category || ''
      var product_line_code = quote.product_line_code || ''
      var price_method = quote.price_method || ''
      var concat_customer_number_product_25 = quote.concat_customer_number_product_25 || ''
      var concat_customer_category_product_25 = quote.concat_customer_category_product_25 || ''
      var concat_customer_category_product_line_code = quote.concat_customer_category_product_line_code || ''

      if(branch !== '01'){
        return 'Excluded Branch'
      }

      if(customer_category === 'INT'){
        return 'INT'
      }

      if(customer_category === 'EXC'){
        return 'Lexicon'
      }

      if (product_line_code === 'REPARTS' || product_line_code === 'REPLABOR' || product_line_code === 'REPOUT' || product_line_code === 'REPRECON') {
        return 'RH Repair'
      }

      if (price_method.includes('C#')) {
        return 'Contract'
      }

      if (price_method.includes('Customer\\Product')) {
        return 'L1'
      }

      if (price_method.includes('Cust Catg\\Product (C1 +')) {
        return 'L3'
      }

      if (price_method.includes('Cust Catg\\PL (C1 +')) {
        return 'L4'
      }

      if(price_method === 'Override'){

        if (this.l1_lookup.includes(concat_customer_number_product_25)) {
          return 'L1'
        }

        if (this.l3_lookup.includes(concat_customer_category_product_25)) {
          return 'L3'
        }
        
        if (this.l4_lookup.includes(concat_customer_category_product_line_code)) {
          return 'L4'
        }
        return 'Other'  
      }

      return 'Other'
    },
    getQuoteOverrideLookupFound(quote) {
      if (quote.price_method !== 'Override') return ''
      if (this.l1_lookup.includes(quote.concat_customer_number_product_25)) return 'TRUE'
      if (this.l3_lookup.includes(quote.concat_customer_category_product_25)) return 'TRUE'
      if (this.l4_lookup.includes(quote.concat_customer_category_product_line_code)) return 'TRUE'
      return ''
    },
    getInvoiceParsedSystemPriceMethod(invoice){
      var branch = invoice.branch
      var customer_category = invoice.customer_category || ''
      var product_line_code = invoice.product_line_code || ''
      var price_method = invoice.calculated_price_method || ''

      if(branch !== '01'){
        return 'Excluded Branch'
      }

      if(customer_category === 'INT'){
        return 'INT'
      }

      if(customer_category === 'EXC'){
        return 'Lexicon'
      }

      if (product_line_code === 'REPARTS' || product_line_code === 'REPLABOR' || product_line_code === 'REPOUT' || product_line_code === 'REPRECON') {
        return 'RH Repair'
      }

      if (price_method.includes('C#')) {
        return 'Contract'
      }

      if (price_method.includes('Customer\\Product')) {
        return 'L1'
      }

      if (price_method.includes('Cust Catg\\Product (C1 +')) {
        return 'L3'
      }

      if (price_method.includes('Cust Catg\\PL (C1 +')) {
        return 'L4'
      }

      // anything that does not meet the above criteria mark as "other"
      return 'Other'

    },
    sizeTable(){
      var wh = window.innerHeight;
      this.table_height = wh - 310
    },
    debouncedSearch: debounce(function(event) {
      this.searchValue = event.target._value.replace(/\$/g, '')
    }, 500),
    formatDate(date){
      return Moment(date).format('MM/DD/YY')
    },
    formatDateTime(timestamp){
      return Moment(timestamp).format('MM/DD/YY hh:mma')
    },
    formatCurrency(value) {
      const absoluteValue = Math.abs(value);
      const sign = value < 0 ? "-" : "";
      const formattedValue = absoluteValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return `${sign}$${formattedValue}`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .table-container{
    position: relative;
    top: 5px;
    margin:0px 10px;
  }

  .calculated-column{
    padding:4px;
    font-style: italic;
  }

  .calculated-column-text{
    color: gray;
    font-weight: bold;
  }  

  table{
    font-size: 10px;
    
  }

  th,td{
    line-height:105%;
    padding:2px;
  }

  th{
    background-color:lightgray;
    color:black;
  }

  .filter-cell{
    padding-bottom:10px;
    line-height: 110%;
    font-size: 14px;
  }

  .filter-label{
    font-weight: bold;
  }  

  .text-button.v-icon {
    font-size: 18px !important;
    position: relative;
    left:5px;
    bottom:2px;
  }

  table {
    border-collapse: collapse;
  }

  .totals-row td {
    background-color: #696969;
    color:white;
    border: none;
    font-weight:bold;
  }  

  .table-note{
    font-size:10px;
  }
</style>
